import { useEffect } from "react";
import { SITE_URL } from "../data/siteData";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

// Client-side SEO: title, description, canonical, Open Graph, Twitter, JSON-LD.
export const Seo = ({ title, description, path, ogTitle, ogDescription, ogImage, jsonLd }) => {
  const jsonLdString = jsonLd ? JSON.stringify(jsonLd) : null;

  useEffect(() => {
    const canonical = `${SITE_URL}${path}`;
    document.title = title;
    setMeta("name", "description", description);
    setLink("canonical", canonical);
    setMeta("property", "og:title", ogTitle || title);
    setMeta("property", "og:description", ogDescription || description);
    setMeta("property", "og:url", canonical);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:image", ogImage || `${SITE_URL}/assets/axis-logo.png`);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", ogTitle || title);
    setMeta("name", "twitter:description", ogDescription || description);

    const scriptId = "axis-jsonld";
    let script = document.getElementById(scriptId);
    if (script) script.remove();
    if (jsonLdString) {
      script = document.createElement("script");
      script.id = scriptId;
      script.type = "application/ld+json";
      script.textContent = jsonLdString;
      document.head.appendChild(script);
    }
  }, [title, description, path, ogTitle, ogDescription, ogImage, jsonLdString]);

  return null;
};

export const ORGANIZATION_JSONLD = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "AXIS Business Solutions",
  url: SITE_URL,
  logo: `${SITE_URL}/assets/axis-logo.png`,
  slogan: "AI Optimization. Human Judgment.",
  founder: { "@type": "Person", name: "Davin Campbell" },
  areaServed: "The Bahamas",
};

export const breadcrumbJsonLd = (crumbs) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: crumbs.map((c, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: c.name,
    item: `${SITE_URL}${c.path}`,
  })),
});

export const serviceJsonLd = (service) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  name: service.name,
  description: service.seo.description,
  provider: { "@type": "Organization", name: "AXIS Business Solutions", url: SITE_URL },
  areaServed: "The Bahamas",
  url: `${SITE_URL}/services/${service.slug}`,
});

export default Seo;
